import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { TextSkeleton } from '@/lib/components';

import { FeaturedTextTranslation } from '@/src/modules/CampaignsModule/components/FeaturedTextTranslation';
import { ITableCampaignActions } from '@/src/modules/CampaignsModule/interfaces/CampaignActions';
import { ITableCampaigns } from '@/src/modules/CampaignsModule/interfaces/Campaigns';

interface SectionHeaderSubtitleProps {
  dataList: ITableCampaigns[] | ITableCampaignActions[] | undefined;
  loading: boolean;
  countRecordsPartial: number;
  countFilters: number;
  i18nKey: string;
}

const SectionHeaderSubtitle = ({
  dataList,
  loading,
  countRecordsPartial,
  countFilters,
  i18nKey,
}: SectionHeaderSubtitleProps) => {
  const { t } = useTranslation();

  const noFiltersMessage = t('CAMPAIGNS_MAIN.noFilters');
  const noResultsMessage = t('noResultsFound');

  return useMemo(() => {
    if (!dataList || loading) return <TextSkeleton />;

    if (countRecordsPartial > 0) {
      if (countFilters > 0) {
        return (
          <Trans
            components={{
              featured: <FeaturedTextTranslation text={countRecordsPartial} />,
            }}
            i18nKey={i18nKey}
          />
        );
      } else {
        return <>{noFiltersMessage}</>;
      }
    } else {
      return <>{noResultsMessage}</>;
    }
  }, [loading, dataList, t]);
};

export default SectionHeaderSubtitle;
